import { TrackingEvent } from "./tracking";

export type FallbackEvent = {
  event: string;
  eventData: Record<string, any>;
};

export type GtmEvent = FallbackEvent;

export function eventToGtmEvent(event: TrackingEvent): GtmEvent {
  return {
    event: event.name,
    eventData: event.properties,
  };
}
